import React from 'react'
import Image from './Image';

interface IconProps {
	src: string;
	alt: string;
	className?: string;
}

const Icon: React.FC<IconProps> = ({ src, alt, className }) => (
	<Image src={src} alt={alt} className={className} />
);

export default Icon;